module.exports = __webpack_public_path__ + "static/media/OrangePeeltshirtart2008.5f145c0b.webp";